module.exports = __webpack_public_path__ + "img/ChinaUnicom.f15139e6.png";